import axios from 'axios';

import { attachForcedLogoutInterceptor } from '@tt/hooks/forcedLogout';

import config from './config';
import { getCookie, removeCookie, setCookie } from './cookie';

const tradingTerminalBaseUrl =
    config.get('TRADING_TERMINAL_BASE_URL') || 'https://tradingterminal.com';

const phantom = axios.create({
    baseURL: config.get('PHANTOM_BASE_URL'),
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json'
    }
});

const parseUserCookie = () => {
    try {
        const raw = getCookie('user');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
    } catch {
        return null;
    }
};

const setPhantomTokenDefaults = (token) => {
    phantom.defaults.headers = phantom.defaults.headers || {};
    phantom.defaults.headers.common = phantom.defaults.headers.common || {};
    phantom.defaults.headers.common.token = token;
};

phantom.interceptors.request.use(
    (originalConfig) => {
        const reqConfig = { ...originalConfig };
        try {
            const cookieUser = parseUserCookie();
            const cookieToken = cookieUser?.token;
            const currentToken = reqConfig?.headers?.token;
            const hasExplicitToken =
                typeof currentToken === 'string'
                    ? currentToken.trim().length > 0
                    : Boolean(currentToken);

            // Only inject cookie token when request doesn't already provide one.
            if (cookieToken && !hasExplicitToken) {
                reqConfig.headers = { ...(reqConfig.headers || {}), token: cookieToken };
            }
        } catch {
            // ignore cookie parsing errors
        }

        return reqConfig;
    },
    (error) => Promise.reject(error)
);

attachForcedLogoutInterceptor(phantom, {
    onCleanup: () => removeCookie('user'),
    onTokenUpgrade: async (newToken) => {
        const cookieUser = parseUserCookie();
        if (!cookieUser || typeof cookieUser !== 'object') return;

        setCookie('user', { ...cookieUser, token: newToken });
        setPhantomTokenDefaults(newToken);
    },
    loginUrl: `${tradingTerminalBaseUrl}/auth/login`
});

export default phantom;
